// ────────────────────────────────────────────────────────────────────
// LearnerOnboarding — May 19, 2026 emotional-foundation shift.
//
// The /onboarding route now renders the calm, conversational 5-step
// LearnerOnboardingFlow. This file is kept as a 3-line shim so the
// existing import contract (App.js, deep-links, auto-redirects on
// first login) continues to work — all real behaviour lives in
// LearnerOnboardingFlow.jsx.
// ────────────────────────────────────────────────────────────────────
import LearnerOnboardingFlow from "./LearnerOnboardingFlow";

export default function LearnerOnboarding() {
  return <LearnerOnboardingFlow />;
}
